import { useContext, useEffect } from 'react'
import { GlobalContext } from '../../services/context/DataContext'
import {
  useNavigate,
  useParams
} from 'react-router-dom'
import { menuItemToLink } from '../../features/adminSideMenu/const/menuItemToLink'

const RedirectionControl = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { activeTabData } = useContext(GlobalContext)
  const [, setActiveTab] = activeTabData

  useEffect(() => {
    const pageName = params && params.pageName
    const menuName = pageName === 'people' ? 'contacts' : pageName
    const tabNumber = menuItemToLink[menuName] || undefined
    // Go to the tab
    navigate('/adminDashboard')
    // Some grid labels do not map directly to menu keys (for example,
    // "commercial zone" versus "commercialZones"). Keep the current menu
    // selected when a redirect does not resolve to a known tab.
    if (tabNumber) setActiveTab(tabNumber)

    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [])

  return false
}

export default RedirectionControl
